define([
    'jQuery',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object',
    'library/fcse-dropdown/dropdown'
    ],
    function($, Widget, Object, Dropdown) {
        
        var TravellersWidget = function (element, options) {
            Widget.apply(this, arguments);
            
            //Set options
            var defaultOptions = {
                'ensureEqualAdults': false, 
                'childLabel' : 'Kind',
                'childLabelPlural' : 'Kinder',
                'adultLabel' : 'Erwachsener',
                'adultLabelPlural' : 'Erwachsene',
                'ageChildLabelSelector' : '.label',
                'ageChildLabel' : 'Alter Kind {0}',
                'moreChildsValue' : 9999,
                'moreAdultsValue' : 9999
            };
            
            //Set defaults from data attribtues
            if ($(element).attr('data-child-label')){
                defaultOptions['childLabel'] = $(element).attr('data-child-label');
            }
            if ($(element).attr('data-child-label-plural')){
                defaultOptions['childLabelPlural'] = $(element).attr('data-child-label-plural');
            }
            if ($(element).attr('data-adult-label')){
                defaultOptions['adultLabel'] = $(element).attr('data-adult-label');
            }
            if ($(element).attr('data-adult-label-plural')){
                defaultOptions['adultLabelPlural'] = $(element).attr('data-adult-label-plural');
            }
            if ($(element).attr('data-age-child-label')){
                defaultOptions['ageChildLabel'] = $(element).attr('data-age-child-label');
            }
            if ($('[data-fcse-role="travellers--morechilds"]').data('value')){
                defaultOptions['moreChildsValue'] = $('[data-fcse-role="travellers--morechilds"]').data('value');
            }
            if ($('[data-fcse-role="travellers--moreadults"]').data('value')){
                defaultOptions['moreAdultsValue'] = $('[data-fcse-role="travellers--moreadults"]').data('value');
            }
            
            this.addOptions(defaultOptions, options);
            
            // Internal array of all age chooser for children
            this.ageChooserList = [];
            this._ageDropdown = $('[data-fcse-role="travellerswidget--agedropdown"]', this.element);
            
            //Instances of the dropdowns
            this.childDropdown = {};
            this.adultDropdown = {};

            this._initDropdowns();
            
            if (this.getValue()){
                this.setValueToUi();
            }
        };

        TravellersWidget.prototype = $.extend(Object.create(Widget.prototype), {
            _initDropdowns : function() {
                this.childDropdown = new Dropdown($('[data-fcse-role="travellerswidget--childdropdown"]', this.element));
                this.childDropdown.on('change', $.proxy(this.onChildrenChange, this));
                
                this.adultDropdown = new Dropdown($('[data-fcse-role="travellerswidget--adultdropdown"]', this.element));
                this.adultDropdown.on('change', $.proxy(this.onAdultsChange, this));
                
                // Detach age chooser from dom and keep as a template
                this._ageDropdown.detach();
                this.onChildrenChange();
            },
            
            onAdultsChange : function(event) {
                var numChildren = parseInt(this.childDropdown.getValue());
                //Make sure we have no more children than parents
                if (this.option('ensureEqualAdults')){
                    if (numChildren > parseInt(this.adultDropdown.getValue())){
                        this.childDropdown.setValue(this.adultDropdown.getValue());
                        return;
                    }
                }
            },
            onChildrenChange : function(event) {
                var numChildren = parseInt(this.childDropdown.getValue());
                numChildrenChanged = false;
                if (this.option('moreChildsValue') != numChildren) {
                    //Make sure we have no more children than parents
                    if (this.option('ensureEqualAdults')){
                        if (numChildren > parseInt(this.adultDropdown.getValue())){
                            this.childDropdown.setValue(this.adultDropdown.getValue());
                            return;
                        }
                    }
                    
                    // Create missing age chooser dropdowns
                    while (this.ageChooserList.length < numChildren) {
                        var ageChooser = this._ageDropdown.clone().appendTo($('[data-fcse-role="travellerswidget--agecontainer"]', this.element));
                        var childAgeDropdown = new Dropdown(ageChooser);
                        childAgeDropdown.element.on('change', $.proxy(this.onChildAgeChange, this));
                
                        //Set title
                        var title = this.option('ageChildLabel').replace('{0}', this.ageChooserList.length + 1);
                        childAgeDropdown.element.find('[data-fcse-role="travellerswidget--agelabel"]').text(title);
                        this.ageChooserList.push(childAgeDropdown);
                    }
                } else {
                    // Triggers when > 4 children item is chosen
                    // Make it behave the same way as it does when no children are chosen
                    numChildrenChanged = numChildren;
                    numChildren = 0;
                }
                
                // Remove unnecessary dropdowns
                for (var i = this.ageChooserList.length - 1; i >= numChildren; i--){
                    if (i === 0){
                        // Keep last dropdown as a template for cloning
                        $(this.ageChooserList[i].element).detach();
                    } else {
                        $(this.ageChooserList[i].element).remove();
                    }
                    
                    this.ageChooserList.pop();
                }
                
                if (numChildrenChanged) {
                    numChildren = numChildrenChanged;
                }
            },
            _processData : function(value) {
                if (value){
                    if ($.isPlainObject(value)){
                        return value;
                    } else {
                        return $.parseJSON(value);
                    }
                } else {
                    return {};
                }
            },
            setValueToUi : function () {
                var val = this.getValue();
                if (val == null) return;

                if (val.adults) {
                    this.adultDropdown.setValue(val.adults);
                }
                if ($.isArray(val.children)) {
                    // Update children dropdown
                    this.childDropdown.setValue(val.children.length);
                    
                    var self = this;
                    $.each(val.children, function(idx, element){
                        // Check if age chooser exists when ensureEqualAdults is true
                        if (self.option('ensureEqualAdults')){
                            if (self.ageChooserList[idx] === undefined){
                                return;
                            }
                        }
                        self.ageChooserList[idx].setValue(element);
                    });
                }
            },
            getValueFromUi : function () {
                var children = [];
                for (var i = 0; i < this.ageChooserList.length; i++){
                    if (this.ageChooserList[i].getValue()){
                        children.push(this.ageChooserList[i].getValue());
                    }
                }
                return {
                    'adults' : this.adultDropdown.getValue(),
                    'children' : children
                };
            },
            formatValue : function() {
                var val = this.getValueFromUi();
                var text = val.adults;
                
                if (val.adults != 1){
                    text += ' ' + this.option('adultLabelPlural');
                } else {
                    text += ' ' + this.option('adultLabel');
                }
                
                if (val.children.length > 0){
                    if (val.children.length != 1){
                        text += ', ' + val.children.length + ' ' + this.option('childLabelPlural');
                    } else {
                        text += ', ' + val.children.length + ' ' + this.option('childLabel');
                    }
                }
                 return text;
            },

            /**
             * Validate data and show errors, if no age is selected
             */
            isValid: function() {
                var val = this.getValue();
                var self = this;
                var dataValid = true;

                // Check if all required ages for children are selected
                $.each(self.ageChooserList, function(idx, element){
                    // Check if age chooser exists when ensureEqualAdults is true
                    if (element.getValue() == undefined){
                        dataValid = false;
                    }
                });

                // Hide / SHow Error message
                if (dataValid){
                    $('[data-fcse-role="travellerswidget--error"]', self.element).hide();
                } else {
                    $('[data-fcse-role="travellerswidget--error"]', self.element).show();
                }

                return dataValid;
            }
        });

        return TravellersWidget;
    }
);



//////////////////
// WEBPACK FOOTER
// ./~/fcse-travellerswidget/travellersWidget.js
// module id = 184
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21